import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import ReactGA from 'react-ga';

import Routes from './util/Routes';
import rootReducer from './util/redux';
import {
  loadWeb3,
  loadWeb3Accounts,
  updateBlockNumber,
  loadNetworks,
} from './util/thunks';
import analytics from './util/analytics';
import injectGlobal from './util/injectGlobal';

// Global styles:
injectGlobal();

// Routing history:
const history = createHistory();

// Analytics:
if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('UA-119896525-1');
}

// Redux Store:
let store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(thunk, routerMiddleware(history), analytics)
);

// Inject and poll web3 data:
// TODO: Let users "sign in" before injecting by default:
store.dispatch(loadWeb3).then(web3 => {

  Promise.all([
    store.dispatch(loadWeb3Accounts),
    store.dispatch(updateBlockNumber),
    store.dispatch(loadNetworks)
  ]);

  setInterval(() => {
    store.dispatch(loadWeb3Accounts);
    store.dispatch(updateBlockNumber);
    store.dispatch(loadNetworks);
  }, 1000);

  console.log('%cMetamask poller initialized', `
    text-transform: uppercase;
    color: #F79220;
  `);

}).catch(err => {
  console.log('%cMetamask not installed! Install at http://metamask.io.', `
    text-transform: uppercase;
    color: #F79220;
  `);
});

console.log('%cWelcome to WWWorld Cup!', `
  font-size: 22px;
  color: #00AD83;
`);
ReactDOM.render(
  <Provider store={store}>
    <Routes history={history} />
  </Provider>
, document.getElementById('root'));

// PWA Service Workers:
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js